import React, { useState } from "react";
import axios from "axios";
import { FaClipboardCheck } from "react-icons/fa";
import {
  FaUser,
  FaPhoneAlt,
  FaEnvelope,
  FaBuilding,
  FaMapMarkerAlt,
  FaCity,
  FaMapPin,
  FaBox,
  FaIdCard,
  FaFileInvoice,
  FaCheckCircle,
} from "react-icons/fa";

import "../css/RegistraionForm.css";

function RegistrationForm() {

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    address: "",
    city: "",
    pincode: "",
    product: "",
    gst: "",
    pan: "",
    aadhaar: "",
    terms: false,
  });

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "phone") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
    }

    if (name === "pincode") {
      newValue = value.replace(/\D/g, "").slice(0, 6);
    }

    if (name === "aadhaar") {
      newValue = value.replace(/\D/g, "").slice(0, 12);
    }

    if (name === "pan") {
      newValue = value.toUpperCase().slice(0, 10);
    }

    if (name === "gst") {
      newValue = value.toUpperCase().slice(0, 15);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  /*
  ==========================
  GOOGLE SHEET SUBMIT
  ==========================

  const handleSubmit = async(e)=>{

      e.preventDefault();

      if(!formData.terms){
          alert("Please accept Terms & Conditions");
          return;
      }

      setLoading(true);

      try{

          const URL="YOUR_GOOGLE_SCRIPT_URL";

          await axios.post(URL,formData);

          alert("Registration Successful");

      }catch(err){

          alert("Something went wrong");

      }

      setLoading(false);

  }

  */

  const handleSubmit = (e) => {

    e.preventDefault();

    if (!formData.terms) {
      alert("Please accept Terms & Conditions");
      return;
    }

    setLoading(true);

    setTimeout(() => {

      console.log(formData);

      alert("Registration Submitted Successfully");

      setLoading(false);

      setFormData({
        name: "",
        phone: "",
        email: "",
        company: "",
        address: "",
        city: "",
        pincode: "",
        product: "",
        gst: "",
        pan: "",
        aadhaar: "",
        terms: false,
      });

    }, 1200);

  };

  return (

    <section className="registration-container">

      <form
        className="registration-form"
        onSubmit={handleSubmit}
      >

        <div className="form-top">

          <div className="form-badge">
    <FaClipboardCheck />
    <span>Registration Portal</span>
</div>

          

        </div>

        <div className="form-grid">

          {/* Full Name */}

          <div className="form-group">

            <label>
              Full Name
              <span>*</span>
            </label>

            <div className="input-box">

              <FaUser className="input-icon" />

              <input
                type="text"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                required
              />

            </div>

          </div>

          {/* Phone */}

          <div className="form-group">

            <label>
              Phone Number
              <span>*</span>
            </label>

            <div className="input-box">

              <FaPhoneAlt className="input-icon" />

              <input
                type="tel"
                name="phone"
                placeholder="Enter mobile number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

            </div>

          </div>

          {/* Email */}

          <div className="form-group">

            <label>
              Email Address
              <span>*</span>
            </label>

            <div className="input-box">

              <FaEnvelope className="input-icon" />

              <input
                type="email"
                name="email"
                placeholder="example@gmail.com"
                value={formData.email}
                onChange={handleChange}
                required
              />

            </div>

          </div>
          <div className="form-group">
            <label>
              Aadhaar Number
              <span>*</span>
            </label>
            <div className="input-box">
              <FaIdCard className="input-icon" />
              <input
                type="text"
                name="aadhaar"
                placeholder="123412341234"
                value={formData.aadhaar}
                onChange={handleChange}
                maxLength={12}
                required
              />
            </div>
          </div>

          {/* Company */}

          <div className="form-group">

            <label>
              Company Name
              <span>*</span>
            </label>

            <div className="input-box">

              <FaBuilding className="input-icon" />

              <input
                type="text"
                name="company"
                placeholder="Enter company name"
                value={formData.company}
                onChange={handleChange}
                required
              />

            </div>

          </div>
                    

         
          {/* City */}

          <div className="form-group">

            <label>
              City
              <span>*</span>
            </label>

            <div className="input-box">

              <FaCity className="input-icon" />

              <input
                type="text"
                name="city"
                placeholder="Enter your city"
                value={formData.city}
                onChange={handleChange}
                required
              />

            </div>

          </div>

          {/* Pincode */}

          <div className="form-group">

            <label>
              Pincode
              <span>*</span>
            </label>

            <div className="input-box">

              <FaMapPin className="input-icon" />

              <input
                type="text"
                name="pincode"
                placeholder="Enter 6 digit pincode"
                value={formData.pincode}
                onChange={handleChange}
                maxLength={6}
                required
              />

            </div>

          </div>

          {/* Product */}

          <div className="form-group">

            <label>
              Product
              <span>*</span>
            </label>

            <div className="input-box">

              <FaBox className="input-icon" />

              <select
                name="product"
                value={formData.product}
                onChange={handleChange}
                required
              >
                <option value="">Select Product</option>
                <option value="Bulk SMS">Bulk SMS</option>
                <option value="Voice Call">Voice Call</option>
                <option value="WhatsApp API">WhatsApp API</option>
                <option value="Email Service">Email Service</option>
                <option value="RCS Messaging">RCS Messaging</option>
              </select>

            </div>

          </div>

          {/* GST */}

          <div className="form-group">

            <label>
              GST Number
              <span>*</span>
            </label>

            <div className="input-box">

              <FaFileInvoice className="input-icon" />

              <input
                type="text"
                name="gst"
                placeholder="22AAAAA0000A1Z5"
                value={formData.gst}
                onChange={handleChange}
                maxLength={15}
                required
              />

            </div>

          </div>

          {/* PAN */}

          <div className="form-group">

            <label>
              PAN Card
              <span>*</span>
            </label>

            <div className="input-box">

              <FaIdCard className="input-icon" />

              <input
                type="text"
                name="pan"
                placeholder="ABCDE1234F"
                value={formData.pan}
                onChange={handleChange}
                maxLength={10}
                required
              />
            </div>
          </div>
          
           <div className="form-group full-width">

            <label>
              Address
              <span>*</span>
            </label>

            <div className="input-box textarea-box">

              <FaMapMarkerAlt className="input-icon" />

              <textarea
                rows="2"
                name="address"
                placeholder="Enter your complete address"
                value={formData.address}
                onChange={handleChange}
                required
              />

            </div>

          </div>

        </div>
        <div className="checkbox">
          <input
            type="checkbox"
            name="terms"
            checked={formData.terms}
            onChange={handleChange}
            required
          />
          <label>
            I agree to the
            <strong> Terms & Conditions </strong>
            and
            <strong> Privacy Policy</strong>.
          </label>
        </div>
        <button
          type="submit"
          className="save-btn"
          disabled={loading}
        >
          {loading ? (
            "Submitting..."
          ) : (
            <>
              <FaCheckCircle />
              <span> Save Registration</span>
            </>
          )}
        </button>
        <div className="enquiry-box">

  <h3>Need Help?</h3>

  <div className="contact-grid">

    <div className="contact-card">
      📞 +91 9876543210
    </div>

    <div className="contact-card">
      ✉️ support@yourcompany.com
    </div>

  </div>

</div>
      </form>
    </section>
  );
}
export default RegistrationForm;